import Abstract from "../../../../abstract-view/abstract.js";

import {
  createElement
} from "../../../../render/render.js";

import {
  EMPTY_TEXT as EMPTY_TEXT_LEXICON
} from "../lexicon.js";

const createEmptyTemplate = () => {
  return (
    `<ul class="products-list">
      <li class="product-item product-item_empty">${EMPTY_TEXT_LEXICON}</li>
    </ul>`
  );
};
export default class Products extends Abstract {
  constructor(element) {
    super();

    this._element = element;
    this._parent = null;

    this._emptyElement = null;
  }

  isEmpty() {
    return (this._element.querySelector(`.product-item_empty`)) ? true : false;
  }

  getParent() {
    if (!this._parent) {
      this._parent = this._element.parentElement;
    }

    return this._parent;
  }

  updateElement(element) {
    this._element = element;
  }

  getInsertsElements() {
    return this._element.querySelectorAll(`.category-insertion`);
  }

  getEmptyElement() {
    if (!this._emptyElement) {
      this._emptyElement = createElement(this._getEmptyTemplate());
    }

    return this._emptyElement;
  }

  setUpdate() {
    this.getParent().classList.add(`${this._parent.classList[0]}_updating`);
  }

  setUpdated() {
    this.getParent().classList.remove(`${this._parent.classList[0]}_updating`);
  }

  _getEmptyTemplate() {
    return createEmptyTemplate();
  }
}
